'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { hasSufficientReportCreatePermission } from 'reporting-action-components/lib/report-logic';
import { INSUFFICIENT_ASSET_PERMISSION_LEVEL } from 'reporting-action-components/reportingActions/problems';
import { jsx as _jsx } from "react/jsx-runtime";
export const getDeleteReportProblem = report => !hasSufficientReportCreatePermission(report);
const useBulkDeleteActionProblem = ({
  selectedRows
}) => {
  const disabledRow = selectedRows.find(report => {
    return getDeleteReportProblem(report);
  });
  if (disabledRow) {
    return {
      problem: INSUFFICIENT_ASSET_PERMISSION_LEVEL,
      disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reports.table.bulkDelete.tooltip.needCreate"
      })
    };
  }
  return {
    problem: null,
    disabledMessage: null
  };
};
export default useBulkDeleteActionProblem;